export function FeaturePageAlbumTags({ values }: { values: Array<string | null | undefined> }) {
  const tags = values.filter((value): value is string => Boolean(value));
  if (tags.length === 0) return null;

  return (
    <div className="mt-1.5 flex min-w-0 flex-wrap gap-1.5">
      {tags.map((tag, index) => (
        <span
          key={`${tag}-${index}`}
          className="inline-block max-w-full truncate rounded-full bg-secondary px-2 py-0.5 text-[11px] font-semibold text-muted-foreground"
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
